export const CLOSE_LABEL = "Close";
export const CANCEL_LABEL = "Cancel";
export const SELECT_LABEL = "Select";
export const CLEAR_LABEL = "No selection";
export const REPLACE_DEL_LABEL = "Replace";

export const CLOSE_WITHOUT_SAVE_LABEL = "Cancel";
export const SAVE_LABEL = "Apply";
export const SAVE_AND_CLOSE_LABEL = "Save";
export const RETRY_SAVE_AND_CLOSE_LABEL = 'Retry save';

export const ADD_AND_CLOSE_LABEL = "Add";
export const RETRY_ADD_AND_CLOSE_LABEL = 'Retry add';


export const SAVE_AS_NEW_LABEL = "Save as new";
export const REPLACE_LABEL = "Replace";
export const OPEN_LABEL = "Open";
export const IMPORT_LABEL = "Import";
export const ADD_LABEL = "Add";
export const NEW_LABEL = "New";
export const EDIT_LABEL = "Edit";
export const DELETE_LABEL = "Delete";
export const DETAILS_LABEL = "Details";
export const OK_LABEL = "Ok";

